import {useEffect, useState} from "react";
import {getEventBookingOptions} from "../api/apiClient";

export const useEventBookingOptions = (eventUuid, reloadTrigger) => {
    const [event, setEvent] = useState([]);
    const [customerProducts, setCustomerProducts] = useState([]);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();
        const eventBookingOptions = getEventBookingOptions(eventUuid, abortController.signal);

        eventBookingOptions
            .then(
                (data) => {
                    const event = data.event;
                    const customerProducts = data.customerProducts;
                    const products = data.products;

                    setEvent(event)
                    setCustomerProducts(customerProducts)
                    setProducts(products)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [eventUuid, reloadTrigger]);

    return {event : event, customerProducts : customerProducts, products : products};
};